export const getAllProductCategoryItems = (
  items,
  additionalItems,
  shopifyCollections = [],
) => {
  items.sort((a, b) => a.position - b.position);

  const allItems = [
    ...items,
    ...additionalItems.filter(({ positionOverride }) => !positionOverride),
  ];

  additionalItems
    .filter(({ positionOverride }) => positionOverride)
    .forEach(additionalItem => {
      allItems.splice(additionalItem.positionOverride - 1, 0, additionalItem);
    });

  return allItems.map(item => ({
    ...item,
    shopifyCollection: shopifyCollections.find(
      ({ handle }) => handle === item.slug,
    ),
  }));
};
